import React from 'react';
import clsx from 'clsx';
import {
  Element,
  FontType,
  Color,
  Typography
} from '@americanexpress/aqx-components';
import Flag from 'page_modules/business-pdp/components/Flag';

import styles from '../__styles__/index.scss?modules';

export const Front = ({ content }) => {
  const { header, imageUrl, imageAlt, text, label } = content;

  return (
    <Element className={styles.frontOfTile}>
      <Element Component="img" src={imageUrl} alt={imageAlt} />
      <Element>
        <Element className={clsx(styles.headerWrap, { [styles.hasFlag]: !!label })}>
          <Typography
            $family={FontType.BentonMedium}
            $size={18}
            $lineHeight={28}
            Component="h3"
            theme={{
              textHeading: 5,
              color: Color.DeepBlue,
              padding: 'none',
              marginTop: 15,
              marginBottom: 5,
              marginLeft: 20,
              marginRight: 20
            }}
          >
            {header}
          </Typography>
          {label && <Flag text={label} />}
        </Element>
        <Typography
          $family={FontType.HelveticaRegular}
          $size={15}
          $lineHeight={22}
          theme={{
            marginBottom: 15,
            marginLeft: 20,
            marginRight: 15,
            marginTop: 0
          }}
        >
          {text}
        </Typography>
      </Element>
    </Element>
  );
};
